import React from "react";
import { Col, Row } from "react-bootstrap";
import { Toggle } from "../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";

export const ExperienceSessionManagement = ({
  experienceManagementSpecial,
  experienceManagementCurated,
  onClickExperience,
  disabled,
}) => {
  return (
    <Col md={9}>
      <Row className="py-2">
        <Col>
          <div className="f20-700 mb-4">Manage Experience</div>
        </Col>
        <Col>
          <div className="f20-700 mb-4">On/Off</div>
        </Col>
        <Col>
          <div className="f20-700 mb-4">Auto Accept</div>
        </Col>
      </Row>
      <Row className="py-1 px-2">
        <Col>
          <div className="f15-500">Occasions</div>
        </Col>
        <Col className="d-flex align-items-center">
          <Toggle
            checked={experienceManagementSpecial}
            toggleFunction={(e) => {
              onClickExperience(e, "SPECIAL");
            }}
            disabled={disabled}
          />
        </Col>
        <Col className="d-flex align-items-center">
          <Toggle checked={false} toggleFunction={() => {}} disabled={true} />
        </Col>
      </Row>
      <Row className="py-1 px-2">
        <Col>
          <div className="f15-500">Events</div>
        </Col>
        <Col className="d-flex align-items-center">
          <Toggle
            checked={experienceManagementCurated}
            toggleFunction={(e) => {
              onClickExperience(e, "CURATED");
            }}
            disabled={disabled}
          />
        </Col>
        <Col className="d-flex align-items-center">
          <Toggle checked={false} toggleFunction={() => {}} disabled={true} />
        </Col>
      </Row>
    </Col>
  );
};
